<template>
  <div class="skillResults">
    <div class="o-ndividualArea c-responsive-fixwidth skill-pad-adjust">
      <div class="o-ndividualTable">
        <div class="c-common-space o-individual-calls">
            <div class="row">
                <div class="col-sm-9">
                    <form class="form-inline">
                        <div class="form-group">
                            <label for="exampleInputEmail3">Sort By</label>
                            <select class="form-control" v-model="sortSkill" @change="sortSkills()">
                                <option value="name">Sort Alphabetically</option>
                                <option value="priotiy">Sort by Order/Priority</option>
                            </select>
                        </div>
                        <!-- <button type="submit" class="c-solid-btn">Go</button> -->
                    </form>
                </div>
                <div class="col-sm-3">
                    <el-tooltip content="Refreshing Skill Cache happens automatically after login. However, you may force a refresh after updating skills. This process can take 1 to 15 minutes, depending on the complexity of the cache." placement="top" effect="dark">
                        <form class="form-inline text-right">
                            <div class="form-group">
                                <label for="exampleInputEmail3 mr-1">Skill Cache Refresh:</label>
                                <el-switch
                                    style="display: inline"
                                    v-model="skill_cache_refresh"
                                    active-color="#13ce66"
                                    inactive-color="#dcdfe6"
                                    :active-value="1"
                                    :inactive-value="0"
                                    @change="changeSkillCacheRefresh()">
                                </el-switch>
                            </div>
                            <!-- <button type="submit" class="c-solid-btn">Go</button> -->
                        </form>
                    </el-tooltip>
                </div>
            </div>
        </div>

        <div class="o-skills-listing" v-loading="loadingSkillList">
            <div class="row">
                <div class="col col-sm-4 skill-listing-left" v-infinite-scroll="loadMore" infinite-scroll-disabled="busy" infinite-scroll-distance="10">
                    <div v-for="(skill,key) in skills" :key="key" :class="(selectedSkillId==skill.id)?'o-skill-box skill-box-mod c-common-gradient c-common-box-shadow skill-box-selected':'o-skill-box skill-box-mod c-common-gradient c-common-box-shadow'">
                      <div class="skill-box-left">
                        <div @click="selectSkill(skill)" class="skill-title">{{(skill.name)? skill.name : "NA"}}</div>
                        <div class="skill-details">
                          <div class="skill-details-box">
                              <p><span>Employees</span></p>
                              <p>{{(skill.employee_count) ? skill.employee_count:'0'}}</p>
                          </div>
                          <div class="skill-details-box">
                              <p><span>Priority</span></p>
                              <p>{{skill.priotiy}}</p>
                          </div>
                          <div class="skill-details-box">
                              <p class="text-center"><span>Notify</span></p>
                              <p class="text-center" :class="getPower('notify')?'':'tabNotifyHide'"><a href="javascript: void(0)" @click="addBatchNotify(skill.id)" class="skill-notify-icon"><i class="fa fa-mobile" aria-hidden="true"></i></a></p>
                          </div>
                        </div>
                        <div class="skill-matric-feature">
                            <div class="cache-for-speed" v-if="userRoleSlug=='client-admin'&&clientData&&clientData.private_skill_memcache_enable">
                                <label class="">Cache For Speed: </label>
                                <el-switch
                                    style="display: inline"
                                    v-model="skill.cache_for_speed"
                                    active-color="#13ce66"
                                    inactive-color="#dcdfe6"
                                    :active-value="1"
                                    :inactive-value="0"
                                    @change="changeStatusCacheForSpeed(skill)">
                                </el-switch>
                            </div>
                            <div class="is-skip-last-next">
                                <label class="">Pass on Next-Last Metric:</label>
                                <el-switch
                                    style="display: inline"
                                    v-model="skill.is_skip_last_next"
                                    active-color="#13ce66"
                                    inactive-color="#dcdfe6"
                                    :active-value="1"
                                    :inactive-value="0"
                                    @change="changeSkipLastNext(skill)">
                                </el-switch>
                            </div>
                        </div>
                      </div>
                      <div class="skill-box-right">
                        <div><i class="fa fa-user" @click="openSkillEmployeeModal(skill.id)" aria-hidden="true"></i></div>
                        <div :class="{'isDisabled':!getPower('editSkill')}"><i class="fa fa-pencil" aria-hidden="true" @click="openEditSkill(skill,key)"></i></div>
                        <div :class="{'isDisabled':!getPower('archiveSkill')}" v-if="checkDefaultSkillArchive(skill)"><i class="fa fa-archive" aria-hidden="true" @click="archiveSkill(skill.id)"></i></div>
                      </div>
                    </div>
                    
                </div>

                <div class="col-sm-8">
                  <div class="skill-assign-holder c-common-gradient c-common-box-shadow" v-loading="employeeListLoad">
              
                    <div class="assign-employee-filter">
                        <div class="row">
                            <div class="col-sm-4">
                                <label class="common-label-text">Status Level:</label>
                                <div class="o-cutsomSelect o-cutsomSelect--inline">
                                    <select v-model="selectStatus" class="skill-select-mod" @change="getEmployeeWithStatusAndSkill()">
                                        <option v-for="(status,index) in employeeStatus" :key="index" :value="status.id"> {{status.name}} </option>
                                        <option value="all"> All </option>
                                    </select>                                   
                                </div>
                                <div class="instruction-text">
                                    Click Save BEFORE change in Status or Search
                                </div>
                            </div>
                            
                            <div class="col-sm-4">
                              <!-- <a @click="updateSkillEmployees()" class="c-solid-btn btn-save-skill">Save</a> -->
                              <p class="c-selected-skill-header"> {{selectedSkillName}} </p>
                            </div>
                            <div class="col-sm-4 text-right">
                              <a href="javascript: void(0)" :class="{'greyBg': userRoleSlug=='auditor'}" @click="updateSkillEmployees()" class="c-solid-btn btn-save-skill">Save</a>
                            </div>
                            <div class="col-sm-4"></div>
                              <div class="col-sm-8">
                                <div class="search-filter-skill">
                                    <div :class="{'isDisabled':!getPower('editSkill')}" class="btn-grp-skill">
                                    <label class="common-label-text">Select:</label>
                                    <a href="javascript: void(0)" @click="selectAllEmployee()" class="c-common-skill">All</a>
                                    <a href="javascript: void(0)" @click="selectNone()" class="c-solid-skill">None</a>
                                    </div><!-- {{selectedEmployees}} -->
                                    <div class="o-search-field search-inner-selector search-inner-skill">
                                    <div class="input-group stylish-input-group input-mod-skill">
                                        <input v-model="skillEmploySearch" @change="filterEmployeeList()" @input="filterEmployeeList()" type="text" placeholder="Search" class="form-control input-control-skill"> 
                                        <span class="input-group-addon">
                                        <button type="submit">
                                                <span v-if="searchPattern">
                                                    <i aria-hidden="true" class="fa fa-close" @click="clearSkillEmploySearch"></i>
                                                </span>
                                                <span v-else>
                                                    <i aria-hidden="true" class="fa fa-search"></i>
                                                </span>
                                        
                                        </button>
                                        </span>
                                    </div>
                                    </div>
                                    
                                </div>
                            </div>
                        </div>
                    </div>
                   <div class="row">
                      <div class="emplisting-container">
                        <div v-if="employeeList.length">
                            <div v-for="(employee, key) in employeeList" :key="key" class="col-sm-6">
                                <div class="assign-employee-list assign-emplisting-mod clearfix">
                                    <div class="checkbox o-custom-radio custom-radio-mod">
                                    <label v-if="employee">
                                        <span v-if="emp_sort == 'fname_desc'">{{employee.employable.last_name + ', ' + employee.employable.first_name }}</span>
                                        <span v-else>{{employee.employable.first_name + ' ' + employee.employable.last_name }}</span>
                                    <input type="checkbox" :id="selectedSkillId" :value="employee.skill_id" v-model="employee.skill_id" @change="changeEmployeeSkillArray(key,selectedSkillId,employee.skill_id)" :disabled="!getPower('editSkill')">
                                    <span class="cr"><i class="cr-icon fa fa-check"></i></span>
                                    </label>
                                    </div>
                                    <div class="assign-input-right">
                                    <input :class="{'isDisabled':!getPower('editSkill')}" type="number" @blur="changeEmployeeSkillArray(key,selectedSkillId,employee.skill_id)" class="form-control" placeholder="Seniority" v-model.number="employee.skill_seniority" @click="checkInput(key)">
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-else class="no-job-dispaly">
                            <i class="fa fa-frown-o" aria-hidden="true"></i>
                            <br />
                            No Records Found
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
            </div>
        </div>
      </div>
    </div>
    <modal name="edit-skill"  height="auto" :scrollable="true" class="modal-dialog modal-sm">
      <div class="modal-add-newJob" tabindex="-1" role="dialog">
         <div  role="document">
             <div class="modal-content o-common-modal-content">
                 <div class="modal-header u-no-border text-center">
                     <button @click="closeEditSkill()" type="button" class="close custom-modal--close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                     <h4 class="modal-title">Edit Skill</h4>
                 </div>
                 <div class="modal-body c-common-box-shadow o-modal-body">
                     <div class="row">
                         <div class="col-sm-12 o-modal-field-area">
                             <div class="col-sm-3 o-right-no-padding o-modal-form-field">
                                 <label class="common-label-text common-label-text--modalwidth">Skill Name:</label>
                             </div>
                             <div class="col-sm-9 o-left-no-padding o-modal-form-field">
                                 <label class="common-label-input--modalwidth o-custom-dropdown">
                                   <input type="text" class="form-control" :disabled="checkDefaultSkillEditName(addSkill.name)" placeholder="Text Input"  v-validate="{required: true}" name="name" v-model="addSkill.name">
                                <span v-show="errors.has('name') && this.validation_err == 1" class="err-msg">{{ errors.first('name') }}</span>
                                 </label>
                             </div>
                         </div>
                     </div>
                     <div class="row">
                         <div class="col-sm-12 o-modal-field-area">
                             <div class="col-sm-3 o-right-no-padding o-modal-form-field">
                                 <label class="common-label-text common-label-text--modalwidth">Sort Priority:</label>
                             </div>
                             <div class="col-sm-9 o-left-no-padding o-modal-form-field">
                                 <label class="common-label-input--modalwidth o-custom-dropdown">
                                           <input type="text" class="form-control" placeholder="Text Input" v-model="addSkill.priotiy">
                                 </label>
                             </div>
                         </div>
                     </div>

                     <div class="row">
                         <div class="col-sm-12 o-modal-field-area">
                             <div class="col-sm-3 o-right-no-padding o-modal-form-field">
                                 <label class="common-label-text common-label-text--modalwidth">Rate A:</label>
                             </div>
                             <div class="col-sm-9 o-left-no-padding o-modal-form-field">
                                 <label class="common-label-input--modalwidth o-custom-dropdown">
                                    <input type="text" class="form-control" placeholder="Rate($)" v-model="addSkill.rate_a">
                                 </label>
                             </div>
                         </div>
                     </div>
                     <div class="row">
                         <div class="col-sm-12 o-modal-field-area">
                             <div class="col-sm-3 o-right-no-padding o-modal-form-field">
                                 <label class="common-label-text common-label-text--modalwidth">Rate B:</label>
                             </div>
                             <div class="col-sm-9 o-left-no-padding o-modal-form-field">
                                 <label class="common-label-input--modalwidth o-custom-dropdown">
                                    <input type="text" class="form-control" placeholder="Rate($)" v-model="addSkill.rate_b">
                                 </label>
                             </div>
                         </div>
                     </div>
                     <div class="row">
                         <div class="col-sm-12 o-modal-field-area">
                             <div class="col-sm-3 o-right-no-padding o-modal-form-field">
                                 <label class="common-label-text common-label-text--modalwidth">Rate C:</label>
                             </div>
                             <div class="col-sm-9 o-left-no-padding o-modal-form-field">
                                 <label class="common-label-input--modalwidth o-custom-dropdown">
                                    <input type="text" class="form-control" placeholder="Rate($)" v-model="addSkill.rate_c">
                                 </label>
                             </div>
                         </div>
                     </div>
                     <div class="row">
                         <div class="col-sm-12 o-modal-field-area">
                             <div class="col-sm-3 o-right-no-padding o-modal-form-field">
                                 <label class="common-label-text common-label-text--modalwidth">Rate D:</label>
                             </div>
                             <div class="col-sm-9 o-left-no-padding o-modal-form-field">
                                 <label class="common-label-input--modalwidth o-custom-dropdown">
                                    <input type="text" class="form-control" placeholder="Rate($)" v-model="addSkill.rate_d">
                                 </label>
                             </div>
                         </div>
                     </div>
                     <div class="row">
                         <div class="col-sm-12 o-modal-field-area">
                             <div class="col-sm-3 o-right-no-padding o-modal-form-field">
                                 <label class="common-label-text common-label-text--modalwidth">Rate E:</label>
                             </div>
                             <div class="col-sm-9 o-left-no-padding o-modal-form-field">
                                 <label class="common-label-input--modalwidth o-custom-dropdown">
                                    <input type="text" class="form-control" placeholder="Rate($)" v-model="addSkill.rate_e">
                                 </label>
                             </div>
                         </div>
                     </div>

                     <div class="row">
                         <div class="col-sm-12 o-modal-field-area">
                             <div class="col-sm-3 o-right-no-padding o-modal-form-field">
                                 <label class="common-label-text common-label-text--modalwidth">Description:</label>
                             </div>
                             <div class="col-sm-9 o-left-no-padding o-modal-form-field">
                                 <label class="common-label-input--modalwidth o-custom-dropdown">
                                   <textarea placeholder="Text Area" v-model="addSkill.description" class="form-control" rows="6" v-validate="{required: true}" name="description"></textarea>
                                     <span v-show="errors.has('description') && this.validation_err == 1" class="err-msg">{{ errors.first('description') }}</span>
                                     </label>
                             </div>
                         </div>
                     </div>
                 </div>
                 <div class="modal-footer text-center">
                     <ul class="o-filter-area">
                         <li>
                             <a href="javascript: void(0)" @click="closeEditSkill()" data-dismiss="modal" aria-label="Close" class="c-common-btn c-common-btn--large c-common-btn--inverse-icon-blue"><i class="fa fa-minus-circle" aria-hidden="true"></i> Cancel</a>
                         </li>
                         <li>
                             <a href="javascript: void(0)" @click="editSkill()" class="c-solid-btn c-solid-btn--large c-solid-btn--green"><i class="fa fa-save"></i> Save</a>
                         </li>
                     </ul>
                 </div>
             </div>
             <!-- /.modal-content -->
         </div>
         <!-- /.modal-dialog -->
     </div>
    </modal>
    <modal name="batch-notify"  height="auto" :scrollable="true" class="modal-dialog modal-sm">
      <div class="modal-add-newJob" tabindex="-1" role="dialog">
          <div  role="document">
              <div class="modal-content o-common-modal-content">
                  <div class="modal-header u-no-border text-center o-small-modal-head">
                      <button @click="closeBatchNotify()" type="button" class="close custom-modal--close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                      <h4 class="modal-title">Batch Notify</h4>
                  </div>
                  <div class="modal-body c-common-box-shadow o-modal-body" v-loading.this.lock="lockNotify">
                      <div class="row">

                          <div class="col-sm-12">
                            <div class="col-sm-12">
                                <label class="common-label-text common-label-text-block">Message:</label>
                                <div class="o-sms-counter">{{sms.length}}/60</div>
                                <textarea maxlength="60" class="form-control o-margin-bottom10" v-model="sms" rows="5" placeholder="Enter your message here"></textarea>
                            </div>
                          </div>
                      </div>
                  </div>
                  <div class="modal-footer text-center">
                      <ul class="o-filter-area">
                          <li>
                              <a href="javascript: void(0)" @click="closeBatchNotify()" data-dismiss="modal" aria-label="Close" class="btn c-common-btn c-common-btn--large c-common-btn--inverse-icon-blue"><i class="fa fa-minus-circle" aria-hidden="true"></i> Cancel</a>
                          </li>
                          <li>
                              <a href="javascript: void(0)" @click="sendNotify()" class="btn c-solid-btn c-solid-btn--large c-solid-btn--green"><i class="fa fa-paper-plane" aria-hidden="true"></i> Send</a>
                          </li>
                      </ul>
                  </div>
              </div>
              <!-- /.modal-content -->
          </div>
          <!-- /.modal-dialog -->
      </div>
    </modal>  
    <modal name="skill-employee-modal" height="auto" width="60%" :scrollable="true" class="modal-dialog modal-sm">
     <div class="modal-add-newJob" tabindex="-1" role="dialog">
        <div  role="document">
            <div class="modal-content o-common-modal-content">
                <div class="modal-header u-no-border text-center">
                    <button type="button" @click="closeSkillEmployee()" class="close custom-modal--close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                    <h4 class="modal-title">{{ employeeSkillDetailsTitle + ' '}} Skill Employee List</h4>
                </div>
                <div class="modal-body c-common-box-shadow o-modal-body">

                    <div class="row">
                        <div class="col-sm-12">
                            <!-- <h2 class="h2 text-center">Please Read Before Upload</h2> -->
                            <!-- <div class="row">
                                <div class="col-sm-12">
                                    <hr class="o-modal-separetor" />
                                </div>
                            </div>
                            <div class="o-accordion-subtext o-rowtable-text form-inline o-rowtable-text">
                                <p class="ps1">To prepare your CSV for the import, you must ensure the following:</p>
                                <ul class="skill-details">
                                    <li>1. The CSV must not contain blank rows which separate valid records.</li>
                                    <li>2. The first row must consist of the field names related to the data</li>
                                    <li>3. Acceptable format for upload: <strong>ods,xlsx,xls.csv</strong></li>
                                </ul>
                            </div> -->
                            <div class="o-accordion-subtext o-rowtable-text form-inline o-rowtable-text">
                                <div class="table-responsive o-no-margin-bottom">
                                  <table id="skill-employee-details" class="table table-bordered o-demo-table o-no-margin-bottom">
                                    <thead>
                                      <tr>
                                        <th>#</th>
                                        <th>Name</th>
                                        <th>Email</th>
                                        <th>Seniority</th>
                                        <th>Skill Seniority</th>
                                        <th>Status</th>
                                        <th>Phone</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr v-for="(emp, inx) in skillEmployee" :key="inx">
                                        <td>{{inx+1}}</td>
                                        <td>{{emp.first_name+' '+emp.last_name}}</td>
                                        <td>{{ emp.email }}</td>
                                        <td>{{ getRoundOffSkillSeniority(emp.employee_seniority) }}</td>
                                        <td>{{ getRoundOffSkillSeniority(emp.skill_seniority) }}</td>
                                        <td>{{emp.name}}</td>
                                        <td>{{ emp.phone_number?emp.phone_number:'' }}</td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                                <!-- <div class="o-emp-csv-download"><strong>- OR -</strong> Download sample <a href="static/assets/download/sample-skill.csv" download class="o-csv-download"><i class="fa fa-download" aria-hidden="true"></i></a></div> -->
                            </div>
                        </div>
                    </div>
                    <!-- <div class="row">
                        <div class="col-sm-12">
                            <hr class="o-modal-separetor" />
                        </div>
                    </div> -->
                    <!-- <div class="row">
                        <div class="col-sm-12">
                            <div class="common-label-input--modalwidth o-upload-file upload-btn-wrapper">
                                <button class="btn c-common-btn c-common-btn--small c-common-btn--green o-csv-upload">Choose File</button>
                                <input class="" type="file" name="myfile" @change="uploadCSV($event)"/>
                                
                            </div>
                        </div>
                    </div> -->
                </div>
                <div class="modal-footer text-center">
                    <ul class="o-filter-area">
                        <li>
                            <a href="javascript: void(0)" @click="closeSkillEmployee()" data-dismiss="modal" aria-label="Close" class="c-common-btn c-common-btn--large c-common-btn--inverse-icon-blue"><i class="fa fa-minus-circle" aria-hidden="true"></i> Cancel</a>
                        </li>
                        <li>
                            <a @click="exportData()" class="c-solid-btn c-solid-btn--large c-solid-btn--green"><i class="fa fa-download"></i> Export Data (.csv)</a>
                        </li>
                    </ul>
                </div>
            </div>
            <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
    </div>
   </modal>
  </div>
</template>
<script>
    import {
        mapGetters,
        mapActions
    } from 'vuex';
    import {
        VueEditor
    } from 'vue2-editor';
    import service from '../../services.js';
    import dateTimeConvert from '../../timeConvert&Compare';
    export default {
        components: {
            VueEditor
        },
        props: ['myProp'],

        watch: {
            async myProp(newVal) { // watch it
                if (typeof newVal == "object") {
                    await this.getAllSkillS();
                    //console.log("test");
                } else {
                    if (newVal == "") {
                        await this.getAllSkillS();
                    } else {
                        if (newVal.length > 1) {
                            this.loadingSkillList=true;
                            this.skills = [];
                            this.storeMore = [];
                            this.next_page = "";
                            await service.get('skill/searchSkills', {
                                    'Authorization': this.userToken,
                                    'cs3-context-role': this.userRole,
                                    'cs3-context-clientId': this.userClientID,
                                    'skillSearch': newVal
                                })
                                .then((res) => {
                                    this.searchData = res.data.result;
                                    this.skills = [];
                                    this.employees = [];
                                    for (var i = 0; i < this.searchData.length; i++) {
                                        if (this.searchData[i].archived == 0) {
                                            this.skills.push(this.searchData[i]);
                                        }
                                    }
                                    this.selectSkill(this.skills[0]);
                                    this.loadingSkillList=false;
                                }).catch((err) => {
                                    console.log(err);
                                    this.loadingSkillList=false;
                                })
                        }
                    }
                }
            }
        },

        computed: {
            ...mapGetters({
                userToken: 'userToken',
                userRole: 'userRole',
                userID: 'userID',
                userClientID: "userClientID",
                getNotificationType: 'getNotificationType',
                userRoleSlug: 'userRoleSlug'
            }),
            filterEmployee() {
                if(!this.skillEmploySearch || this.skillEmploySearch == '')
                    return this.employees;

                return this.employees.filter((employee) => ((employee.employable&&employee.employable.first_name && employee.employable.first_name.toLowerCase().indexOf(this.skillEmploySearch.toLowerCase())!=-1) || (employee.employable&&employee.employable.last_name && employee.employable.last_name.toLowerCase().indexOf(this.skillEmploySearch.toLowerCase())!=-1)  ));
            }
        },

        data() {
            return {
                intervalId: null,
                timerState: null,
                polling:null,
                skill_cache_refresh: 0,
                employeeSkillDetailsTitle: '',
                clientData: null,
                emp_sort: '',
                tempSelectStatus: null,
                searchPattern: false,
                employeeList: [],
                employeeListLoad: false,
                global_skills_updated: [],
                skill_id_selected: '',
                skills: [],
                lockNotify: false,
                loadingSkillList:false,
                loadmoreloading:false,
                afterApi:false,
                total: 0,
                storeMore: [],
                page_no: 3,
                sortSkill: 'name',
                addSkill: {
                    'name': "",
                    'priotiy': "",
                    'description': "",
                    'client_id': '',
                    'rate_a': '',
                    'rate_b': '',
                    'rate_c': '',
                    'rate_d': '',
                    'rate_e': ''
                },
                next_page: "",
                search_query: "",
                validation_err: 0,
                status_message: "",
                skill_id: 0,
                skill_key: 0,
                lockEmployees: false,
                employeeStatus: [],
                selectStatus: null,
                selectedSkillId:'',
                selectedSkillName:'',
                // selectedEmployees: [],
                loading: false,
                selectSkillId: '',
                selectedFilter: null,
                selectedEmpId: [],
                skillEmploySearch:'',
                employees:[],
                skillEmployee:[],
                // emailContent: '',
                // smsContent: '',
                sms:'',
                notifyTab: 'email',
                notifySkillID: [],
                
                attachment : null,
            }
        },

        async beforeMount() {
            await this.getAllSkillS();
        },

        async mounted() {
            await this.getClient()
            this.startPolling();
            // await this.getAllSkillS();
            // this.selectStatus = this.skills[0];
            // await this.getEmployeeStatus();

        },
        async created() {
            // this.pollData();
            // this.getSkillCacheRefreshState();
            // document.onmousemove = this.pollData;
            // document.onmousedown = this.pollData; // touchscreen presses
            // document.ontouchstart = this.pollData;
            // document.onclick = this.pollData;     // touchpad clicks
            // document.onscroll = this.pollData;    // scrolling with arrow keys
            // document.onkeydown = this.pollData;
        },
        beforeDestroy() {
            this.stopPolling();
        },

        methods: {
            startPolling() {
                this.getSkillCacheRefreshState(); // Initial fetch
                this.intervalId = setInterval(this.getSkillCacheRefreshState, 60000); // Fetch every 60 seconds
            },
            stopPolling() {
                if (this.intervalId) {
                    clearInterval(this.intervalId);
                }
            },
            // pollData () {
            //     console.log("Check Poll")
            //     this.polling = setInterval(() => {
            //         // console.log(document.visibilityState);
            //         // document.addEventListener('visibilitychange', () => {
            //             if(document.visibilityState === 'visible'){
            //                 this.timerState = "Started"
            //             }else {
            //                 this.timerState = "Paused"
            //             }
            //         // })

                
            //         if (this.timerState === "Started") {
            //             // console.log("Call Api");
            //             this.getSkillCacheRefreshState();
            //         }
            //     }, 60000);
            // },
            async getSkillCacheRefreshState() {
                console.log("skill_cache_refresh:...",this.skill_cache_refresh);
                // let formData = {
                //     skill_cache_refresh: this.skill_cache_refresh
                // };
                // console.log(formData);
                // client/26a8240d-4fc7-4201-a0e5-93ad0e77c0f0/skillCacheRefresh
                await service.get(`client/${this.userClientID}/checkSkillCacheRefreshStatus`, {
                    'Authorization': this.userToken
                }).then((res) => {
                    console.log(res.data)
                    if(res.data) {
                        this.skill_cache_refresh = res.data.status ? 1 : 0;
                    }
                    // this.$notify({
                    //     title: this.$t('success'),
                    //     message: 'Updated Successfully.',
                    //     type: 'success'
                    // });
                }).catch((err) => {
                    this.$notify({
                        title: this.$t('error'),
                        message: 'Something went wrong!',
                        type: 'error'
                    });
                });
            },
            async changeSkillCacheRefresh() {
                console.log("skill_cache_refresh:...",this.skill_cache_refresh);
                let formData = {
                    skill_cache_refresh: this.skill_cache_refresh
                };
                console.log(formData);
                // client/26a8240d-4fc7-4201-a0e5-93ad0e77c0f0/skillCacheRefresh
                await service.post(`client/${this.userClientID}/skillCacheRefresh`, formData, {
                    'Authorization': this.userToken
                }).then((res) => {
                    this.$notify({
                        title: this.$t('warning'),
                        message: 'Update is in progress...',
                        type: 'warning'
                    });
                }).catch((err) => {
                    this.$notify({
                        title: this.$t('error'),
                        message: 'Something went wrong!',
                        type: 'error'
                    });
                });
            },
            async changeStatusCacheForSpeed(skill) {
                let formData = {
                    cache_for_speed: skill.cache_for_speed
                };
                console.log(formData);
                await service.post(`skill/${skill.id}/updateSkillCacheForSpeed`, formData, {
                    'Authorization': this.userToken
                }).then((res) => {
                    this.$notify({
                        title: this.$t('success'),
                        message: 'Updated Successfully.',
                        type: 'success'
                    });
                }).catch((err) => {
                    this.$notify({
                        title: this.$t('error'),
                        message: 'Something went wrong!',
                        type: 'error'
                    });
                });
            },
            async changeSkipLastNext(skill) {
                let formData = {
                    is_skip_last_next: skill.is_skip_last_next
                };
                await service.post(`skill/${skill.id}/updateSkillSkipNextLast`, formData, {
                    'Authorization': this.userToken
                }).then((res) => {
                    this.$notify({
                        title: this.$t('success'),
                        message: 'Updated Successfully.',
                        type: 'success'
                    });
                }).catch((err) => {
                    this.$notify({
                        title: this.$t('error'),
                        message: 'Something went wrong!',
                        type: 'error'
                    });
                });
            },
            async getClient(){
                await service.get('client/' + this.userClientID, {
                    'Authorization': this.userToken
                }).
                then((res) => {
                    //this.turnoverTime=res.data.result.turnover;
                    this.clientData = res.data.result;
                    this.emp_sort = this.clientData.default_employee_sort                
                }).catch((err) => {
                    console.log(err);
                });        
            },

            checkDefaultSkillArchive(skill) {
                let name = skill.name.toLowerCase();
                // console.log(name);
                // console.log(skill.name.toLowerCase());
                if(name == 'steward' || name == 'dispatched by' || name == 'rss feed' || name == 'penalty rules')
                    return false;
                return true;
            },

            checkDefaultSkillEditName(skillName) {
                let name = skillName.toLowerCase();
                // console.log(skillName.toLowerCase());
                if(name == 'steward' || name == 'dispatched by' || name == 'rss feed' || name == 'penalty rules')
                    return true;
                return false;
            },

            openSkillEmployeeModal(id){
                this.skillEmployee = [];
                this.employeeSkillDetailsTitle = '';
                // console.log('openSkillEmployeeModal');
                // let payload = {
                //     'skill_id':this.selectedSkillId,
                //     'status_id':this.selectStatus,
                // }
                // if(this.emp_sort != '') {
                //     payload.sort = this.emp_sort;
                // }else {
                //     payload.sort = 'fname_asc';
                // }
               this.$modal.show('skill-employee-modal');
               let header = {
                   'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID,
                    'clientId': this.userClientID,
                    'skillId': id
               }

               if(this.emp_sort != '') {
                    header.sort = this.emp_sort;
                }else {
                    header.sort = 'fname_asc';
                }

               service.get('employee/getEmployeeSkillDetails', header)
               .then((res) => {
                    this.skillEmployee=res.data.result;
                    this.employeeSkillDetailsTitle = res.data.result && res.data.result.length && res.data.result[0].skill_name ? res.data.result[0].skill_name:''
                    // console.log(res);
                }).catch(err =>{
                    console.log(err);
                });
            },

            closeSkillEmployee(){
                this.$modal.hide('skill-employee-modal');
            },

            exportData(){
                // this.copyToClipboard('skill-employee-details');
                let employee=[];
                this.skillEmployee.forEach(emp =>{
                    var temp={
                        'Employee ID': emp.id,
                        'Email': emp.email,
                        'Employee Name': emp.first_name+' '+emp.last_name,
                        'Employee Seniority': emp.employee_seniority?emp.employee_seniority:'',
                        'Skill Seniority': emp.skill_seniority?emp.skill_seniority:'',
                        'Employee Status': emp.name,
                        'Phone Number': emp.phone_number?emp.phone_number:''
                    }
                    employee.push(temp);
                });
                this.JSONToCSVConvertor(employee, this.employeeSkillDetailsTitle + " Skill Employees", true);
            },

            JSONToCSVConvertor(JSONData, ReportTitle, ShowLabel) {
                var arrData = typeof JSONData != 'object' ? JSON.parse(JSONData) : JSONData;

                var CSV = '';
                //Set Report title in first row or line

                CSV += ReportTitle + '\r\n\n';

                //This condition will generate the Label/Header
                if (ShowLabel) {
                    var row = "";

                    //This loop will extract the label from 1st index of on array
                    for (var index in arrData[0]) {

                        //Now convert each value to string and comma-seprated
                        row += index + ',';
                    }

                    row = row.slice(0, -1);

                    //append Label row with line break
                    CSV += row + '\r\n';
                }

                //1st loop is to extract each row
                for (var i = 0; i < arrData.length; i++) {
                    var row = "";

                    //2nd loop will extract each column and convert it in string comma-seprated
                    for (var index in arrData[i]) {
                        row += '"' + arrData[i][index] + '",';
                    }

                    row.slice(0, row.length - 1);

                    //add a line break after each row
                    CSV += row + '\r\n';
                }

                if (CSV == '') {
                    alert("Invalid data");
                    return;
                }

                //Generate a file name
                var fileName = "Job_";
                //this will remove the blank-spaces from the title and replace it with an underscore
                fileName += ReportTitle.replace(/ /g, "_");

                //Initialize file format you want csv or xls
                var uri = 'data:text/csv;charset=utf-8,' + escape(CSV);

                // Now the little tricky part.
                // you can use either>> window.open(uri);
                // but this will not work in some browsers
                // or you will not get the correct file extension

                //this trick will generate a temp <a /> tag
                var link = document.createElement("a");
                link.href = uri;

                //set the visibility hidden so it will not effect on your web-layout
                link.style = "visibility:hidden";
                link.download = fileName + ".csv";

                //this part will append the anchor tag and remove it after automatic click
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            },            

            getPower(data) {
                return dateTimeConvert.checkAccess(data);
            },

            sendNotify(){
              var formData;
              if(this.sms != ''){
                formData = {
                    message: this.sms,
                    //email: this.sms,
                    client_id: this.userClientID,
                    skill_id:this.notifySkillID[0],
                    user_id: this.userID
                };
                this.lockNotify=true;
                service.post('skill/notifyBySkill', formData, {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID,
                })
                .then((res) => {
                    //console.log(res);
                    this.lockNotify=false;
                    this.$notify({
                        title: this.$t('success'),
                        message: 'Notify Successfully.',
                        type: 'success'
                    });
                    this.$modal.hide('batch-notify');
                }).catch((err) => {
                    console.log(err);
                    this.lockNotify=false;
                });
                // service.post('employee/notifyEmployeeBySkill', formData, {
                //     'Authorization': this.userToken,
                //     'cs3-context-role': this.userRole,
                //     'cs3-context-clientId': this.userClientID,
                // })
                // .then((res) => {
                //     //console.log(res);
                //     formData = {
                //         sms: this.sms,
                //         //email: this.sms,
                //         client_id: this.userClientID,
                //         skills: JSON.stringify(this.notifySkillID)
                //     };
                //     service.post('employee/notifyEmployeeBySkill', formData, {
                //         'Authorization': this.userToken,
                //         'cs3-context-role': this.userRole,
                //         'cs3-context-clientId': this.userClientID,
                //     })
                //     .then((res) => {
                //         //console.log(res);
                //         this.lockNotify=false;
                //         this.$notify({
                //             title: this.$t('success'),
                //             message: 'Notify Successfully.',
                //             type: 'success'
                //         });
                //         this.$modal.hide('batch-notify');
                //     }).catch((err) => {
                //         console.log(err);
                //         this.lockNotify=false;
                //     });
                //     //this.$modal.hide('batch-notify');
                // }).catch((err) => {
                //     console.log(err);
                //     this.lockNotify=false;
                // });
              }else{
                this.$notify.error({
                  title: this.$t('error'),
                  message: 'You cannot send a blank message.'
                });
              }
            },

            addBatchNotify(skillID) {
                //console.log("SKILL", skillID);
                this.notifySkillID = [];
                this.notifySkillID.push(skillID);
                this.sms="";
                // this.emailContent = "";
                // this.smsContent = "";
                this.$modal.show('batch-notify');
            },

            closeBatchNotify() {
                this.$modal.hide('batch-notify');
            },

            getAllSkillS() {
                this.$Progress.start();
                this.storeMore = [];
                this.next_page = "";
                this.loadingSkillList=true;
                this.afterApi=false;
                service.get('skill', {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID,
                }).then((res) => {
                    this.skills = res.data.result.data;
                    // console.log(this.skills);
                    this.sortSkills();
                    this.selectSkill(this.skills[0]);
                    this.selectStatus = this.skills[0];
                    this.employeeListLoad = true;
                    this.getEmployeeStatus();
                    this.loadingSkillList=false;
                    this.afterApi=true;
                    this.total = res.data.result.total;
                    this.$Progress.finish();
                    this.next_page = res.data.result.next_page_url;
                    if (this.next_page != null || this.next_page == "") {
                        this.loadmoreloading=true;
                        service.getUrl(this.next_page, {
                            'Authorization': this.userToken,
                            'cs3-context-role': this.userRole,
                            'cs3-context-clientId': this.userClientID,
                        }).then((more) => {
                            this.storeMore = more.data.result.data;
                            this.next_page = more.data.result.next_page_url;
                            this.loadmoreloading=false;
                            //console.log(more);
                        }).catch((err) => {
                            console.log(err);
                            this.loadmoreloading=false;
                        });
                    }
                    
                }).catch((err) => {
                    console.log(err);
                    this.$Progress.finish();
                    this.loadingSkillList=false;
                    this.afterApi=true;
                });
                this.addSkill.client_id = this.userClientID;
            },

            loadMore() {
                var arr = this.skills;
                if (this.storeMore.length != 0) {
                    this.storeMore.forEach(function(entry) {
                        arr.push(entry);
                    })
                    // this.sortSkills();
                    this.storeMore = [];
                    // this.loadmoreloading=true;
                    if (this.next_page != null || this.next_page != "") {
                        service.getUrl(this.next_page, {
                            'Authorization': this.userToken,
                            'cs3-context-role': this.userRole,
                            'cs3-context-clientId': this.userClientID,
                        }).then((res) => {
                            this.storeMore = res.data.result.data;
                            this.page_no += 1;
                            this.next_page = res.data.result.next_page_url;
                            // this.loadmoreloading=false;

                        }).catch((err) => {
                            console.log(err);
                            // this.loadmoreloading=false;
                        });
                    }
                } else
                    this.storeMore = [];
            },

            sortSkills() {
                if (this.sortSkill == "name") {
                    this.skills.sort(function(a, b) {
                        if (a.name < b.name) return -1;
                        if (a.name > b.name) return 1;
                        return 0;
                    })
                } else {
                    this.skills.sort(function(a, b) {

                        if (a.priotiy < b.priotiy) return -1;
                        if (a.priotiy > b.priotiy) return 1;
                        return 0;
                    })
                }
                this.selectSkill(this.skills[0]);
                // this.selectedSkillId=this.skills[0].id;
            },

            addNewSkill() {
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        this.validation_err = 0;

                        service.post('skill', this.addSkill, {
                                'Authorization': this.userToken,
                                'cs3-context-role': this.userRole,
                                'cs3-context-clientId': this.userClientID,
                            })
                            .then((res) => {
                                this.status_message = res.data.status_message;
                                setTimeout(() => {
                                    this.$modal.hide('add-skill');
                                }, 500);
                                this.$notify({
                                    title: this.$t('success'),
                                    message: 'Skill Added Successfully.',
                                    type: 'success'
                                });
                                //this.skills=[];
                                this.getAllSkillS();
                            }).catch((err) => {
                                console.log(err);
                            })

                    } else
                        this.validation_err = 1;

                });
            },

            addSkillModal() {
                this.addSkill['name'] = "";
                this.addSkill['description'] = "";
                this.addSkill['priotiy'] = "";
                this.status_message = "";
                this.addSkill.rate_a = '';
                this.addSkill.rate_b = '';
                this.addSkill.rate_c = '';
                this.addSkill.rate_d = '';
                this.addSkill.rate_e = '';
                this.$modal.show('add-skill');
            },

            closeAddSkill() {
                this.$modal.hide('add-skill');
            },

            openEditSkill(skill, key) {
                this.skill_key = key;
                this.status_message = "";
                this.addSkill.name = skill.name;
                this.addSkill.description = skill.description;
                this.addSkill.priotiy = skill.priotiy;
                // console.log(skill.skill_rates);
                let skill_rates = ['rate_a','rate_b','rate_c','rate_d','rate_e']
                for(let i=0;i<skill.skill_rates.length; i++) {
                    this.addSkill[skill_rates[i]]=skill.skill_rates[i].amount;
                    // this.addSkill.rate_a = skill.skill_rates[i].amount;
                    // this.addSkill.rate_b = skill.rate_b?skill.rate_b:'';
                    // this.addSkill.rate_c = skill.rate_c?skill.rate_c:'';
                    // this.addSkill.rate_d = skill.rate_d?skill.rate_d:'';
                    // this.addSkill.rate_e = skill.rate_e?skill.rate_e:'';
                }
                // console.log(this.addSkill);              
                this.skill_id = skill.id;
                this.$modal.show("edit-skill");
            },

            closeEditSkill() {
                this.$modal.hide('edit-skill');
            },
            
            editSkill() {
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        this.validation_err = 0;
                        service.put('skill/' + this.skill_id, this.addSkill, {
                                'Authorization': this.userToken,
                                'cs3-context-role': this.userRole,
                                'cs3-context-clientId': this.userClientID,
                            })
                            .then((res) => {
                                //console.log(res);
                                this.skills[this.skill_key].name = this.addSkill.name;
                                this.skills[this.skill_key].description = this.addSkill.description;
                                this.skills[this.skill_key].priotiy = this.addSkill.priotiy;
                                this.status_message = res.data.status_message;
                                this.getAllSkillS();
                                setTimeout(() => {
                                    this.$modal.hide('edit-skill');
                                }, 500);
                                this.$notify({
                                    title: this.$t('success'),
                                    message: 'Skill Updated Successfully.',
                                    type: 'success'
                                });
                            }).catch((err) => {
                                console.log(err);
                                this.$notify({
                                    title: this.$t('error'),
                                    message: 'Something went wrong!',
                                    type: 'error'
                                });
                            })


                    } else
                        this.validation_err = 1;

                });
            },

            archiveSkill(skillId) {
                this.$confirm('This will permanently archive the skill. Continue?', 'Warning', {
                    confirmButtonText: 'OK',
                    cancelButtonText: 'Cancel',
                    type: 'warning'
                }).then(() => {
                    this.$Progress.start();
                    // console.log(skillId);
                    service.get('skill/' + skillId + '/archiveASkill', {
                        'Authorization': this.userToken,
                        'cs3-context-role': this.userRole,
                        'cs3-context-clientId': this.userClientID,
                    }).
                    then((res) => {
                        this.$Progress.finish();
                        this.$message({
                            type: 'success',
                            message: 'Archived Successfully.'
                        });
                        this.getAllSkillS();
                    }).catch((err) => {
                        console.log(err);
                    });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: 'Archive canceled.'
                    });
                });
            },
            
            getEmployeeStatus(){
                // console.log("Get EmployeeStatus")
              service.get('employee/employee_status', {
                  'Authorization': this.userToken,
                  'cs3-context-role': this.userRole,
                  'cs3-context-clientId': this.userClientID,
              }).
              then((res) => {
                  this.employeeStatus = res.data.result;
                //   console.log(this.employeeStatus)
                  this.employeeStatus.sort(function(a, b) {

                      if (Number(a.priority) < Number(b.priority)) return -1;
                      if (Number(a.priority) > Number(b.priority)) return 1;
                      return 0;
                  });
                    this.selectStatus=this.employeeStatus[0].id;
                    this.getEmployeeWithStatusAndSkill();
                    // console.log("get Employee Status");
                  // this.$Progress.finish();
                  // this.loading = false;
              }).catch((err) => {
                  console.log(err);
                  // this.$Progress.finish();
                  // this.loading = false;
              });
            },

            selectAllEmployee() {
                this.global_skills_updated = [];
                this.selectedFilter = 'all';

                // this.selectedEmployees=this.employees;
                let self = this;
                
                this.filterEmployee.forEach(function(emp) {
                    emp.skill_id=self.selectedSkillId;
                    emp.skill_seniority = emp.employee_skills&&emp.employee_skills.length?emp.employee_skills[0].seniority:null;
                    self.global_skills_updated.push(emp);
                });
                this.employeeList = this.global_skills_updated;
            },

            selectNone() {
                this.global_skills_updated = [];
                this.selectedFilter = 'none';
                let self = this;
                this.filterEmployee.forEach(function(emp) {
                    // emp.skill_id=null;
                    emp.skill_id=null;
                    // this.global_skills_updated = [];
                    self.global_skills_updated.push(emp);
                });
                this.employeeList = this.global_skills_updated;
            },

            checkInput(index){
            //   console.log(index);
            //   console.log(typeof this.employees[index].skill_seniority);
            //   console.log(this.employees[index].skill_id);
              if(this.employees[index].skill_seniority==0){
                this.employees[index].skill_seniority=null;  
              }
            },

            changeEmployeeSkillArray(index,skillId,value) {
                let global_index = this.global_skills_updated.findIndex((element) => element.id == this.filterEmployee[index].id);
                if(this.global_skills_updated.length && global_index !== -1) {
                    this.global_skills_updated[global_index].id = this.filterEmployee[index].id;
                    this.global_skills_updated[global_index].name = this.filterEmployee[index].employable.first_name + ' ' + this.filterEmployee[index].employable.last_name;
                    this.global_skills_updated[global_index].skill_id = value;
                    this.global_skills_updated[global_index].skill_seniority = this.filterEmployee[index].skill_seniority;                
                }else {
                    let tempObj = {
                        id: this.filterEmployee[index].id,
                        skill_id: value,
                        name: this.filterEmployee[index].employable.first_name + ' ' + this.filterEmployee[index].employable.last_name,
                        skill_seniority: this.filterEmployee[index].skill_seniority,
                    };
                    this.global_skills_updated.push(tempObj);
                }
            },

            updateSkillEmployees(){
              if(this.userRoleSlug=='auditor') {
                return;
              }
                // console.log(typeof this.global_skills_updated)
                // console.log(this.global_skills_updated)
              this.employeeListLoad = true;
              service.post('employee/updateEmployeeSkills',{
                'status_id':this.selectStatus,
                'skill_id':this.selectedSkillId,
                'skill_employee': this.global_skills_updated,

              }, {
                  'Authorization': this.userToken,
                  'cs3-context-role': this.userRole,
                  'cs3-context-clientId': this.userClientID,
              }).then((res) => {
                    this.$notify({
                        title: this.$t('success'),
                        message: 'Skill Updated Successfully.',
                        type: 'success'
                    });
                    this.global_skills_updated = [];
                    this.getEmployeeWithStatusAndSkill();
              }).catch((err) => {
                  this.employeeListLoad = false;
                  console.log(err);
              });
            },
            
            selectSkill(skill){
                this.selectedSkillId=skill.id;
                this.selectedSkillName=skill.name;
                this.getEmployeeWithStatusAndSkill();
            },

            async getEmployeeWithStatusAndSkill(){
                this.employeeListLoad = true;
                let header = {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID
                }
                
                let payload = {
                    'skill_id':this.selectedSkillId,
                    'status_id':this.selectStatus,
                }
                if(this.emp_sort != '') {
                    payload.sort = this.emp_sort;
                }else {
                    payload.sort = 'fname_asc';
                }
                this.tempSelectStatus = this.selectStatus;
                if(this.skills!==[]&&this.selectStatus&&this.selectStatus!=""){
                    this.$Progress.start();
                    await service.post('employee/getEmployeeSkillSeniority', payload, header).then((res) => {
                        this.employees=res.data.result;
                        let self=this;
                        this.employees.forEach((emp) => {
                            emp.skill_id = emp.employee_skills && emp.employee_skills.length ? emp.employee_skills[0].skill_id : null;
                            emp.skill_seniority = emp.employee_skills && emp.employee_skills.length ? this.getRoundOffSkillSeniority(emp.employee_skills[0].seniority) : null
                        })
                    }).catch((err) => {
                        console.log(err);
                        this.employeeListLoad = false;
                    });  
                    this.employeeList = this.filterEmployee;
                }
                this.employeeListLoad = false;

            },

            getRoundOffSkillSeniority(seniorityVal) {     
                // console.log(seniorityVal); 
                if(seniorityVal && seniorityVal != '') {          
                    if(seniorityVal.valueOf() == parseInt(seniorityVal)){
                        let x = parseInt(seniorityVal);
                        return x;
                    }
                }
                return seniorityVal;
            },

            async filterEmployeeList() {
                if(this.skillEmploySearch.length > 0) {
                    this.searchPattern = true;
                    if(this.selectStatus != 'all') {
                        let temp = this.selectStatus;
                        this.tempSelectStatus = temp;
                        this.selectStatus = "all"
                        if(this.skillEmploySearch.length == 1)
                            await this.getEmployeeWithStatusAndSkill();
                    } else {
                        this.searchPattern = true;
                        this.tempSelectStatus = 'all'
                    }                    
                } else {
                    this.searchPattern = false;
                    this.selectStatus = this.tempSelectStatus;
                    await this.getEmployeeWithStatusAndSkill();
                }               
                this.employeeList = this.filterEmployee;
            },
             
            async clearSkillEmploySearch() {
                this.skillEmploySearch = "";
                this.searchPattern = false;
                if(this.tempSelectStatus != null || this.tempSelectStatus != "")
                    this.selectStatus = this.tempSelectStatus;
                else this.selectStatus = 'all'
                await this.getEmployeeWithStatusAndSkill();
                this.employeeList = this.filterEmployee;
            }
        }
    }

</script>
<style scoped>
    .skill-matric-feature {
        /* border-top: solid 2px #f9f9f9; */
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-direction: row;
    }
    .skill-matric-feature label {
        padding-right: 3px;
    }
    .cache-for-speed {
        /* float: left; */
        padding: 5px 10px 3px 2px;
        font-size: 13px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-direction: row;
        /* border-right: solid 1px #f9f9f9; */
    }
    .is-skip-last-next {
        /* float: right; */
        padding: 5px 2px 3px 10px;
        font-size: 13px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-direction: row;
    }
    .greyBg {
        background-color: #c5c5c5!important;
        cursor: not-allowed;
        color: #e1e1e1;
    }
    .instruction-text {
        color: #ff1010;
        font-size: 12px;
        font-weight: bold;
        padding-top: 10px;
    }
    .skill-seniority-input-span{
        display: inline-block;
        margin-left: 10px;
        width: 35%;
    }
    .remove-employee-skill-span{
        display: inline-block;
        /* float: right; */
        margin-top: 10px;
        width: 10%
    }
    .employee-skill-list-width{
        width: 50%;
        display: inline-block;
    }

    .form-control-1 {
        display: block;
        float: right;
        width: 25%;
        height: 34px;
        padding: 6px 12px;
        font-size: 14px;
        line-height: 1.42857;
        color: #555;
        background-color: #fff;
        background-image: none;
        border: 1px solid #ccc;
        border-radius: 4px;
        -webkit-box-shadow: inset 0 1px 1px rgba(0,0,0,0.075);
        box-shadow: inset 0 1px 1px rgba(0,0,0,0.075);
        -webkit-transition: border-color ease-in-out 0.15s,box-shadow ease-in-out 0.15s;
        -o-transition: border-color ease-in-out 0.15s,box-shadow ease-in-out 0.15s;
        transition: border-color ease-in-out 0.15s,box-shadow ease-in-out 0.15s;
    }
    .assign-employee-list ul li {
        width: 100%;
        float: left;
        padding: 5px 10px;
    }
    .assign-employee-list ul {
        overflow-x: hidden;
        overflow-y: scroll;
        margin: 20px -10px 10px;
        background: #F4F7F8;
        max-height: 350px;
    }

    .o-custom-radio{
        display: inline-block;
        margin-top: 9px;
        margin-bottom: 5px;
        margin-right: 5px;
    }
    .c-selected-skill-header{
        font-size: 21px;
        font-weight: 600;
        text-align:center;
        margin-top: 6px;
    }
    .skill-select-mod{
        width:130px;
    }
    @media screen and (min-width:1366px){
        .skill-select-mod{
        width:120px;
        }
    }
    .skill-pad-adjust{
        padding: 0;
    }
</style>



// WEBPACK FOOTER //
// src/components/skills/skillList.vue